import { useEffect, useMemo, useState } from 'react';
import { api } from '../api';

// Живые позиции курьеров для карты админа: снимок через GET /locations + SSE
// /locations/stream с короткоживущим токеном (EventSource не умеет заголовки).
// При обрыве — перевыпуск токена и переподключение с backoff.

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function useCourierLocationsStream(enabled) {
  const [byId, setById] = useState({});
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) { setById({}); return undefined; } // иначе «Онлайн N» застывает при свёрнутой карте
    let es = null;
    let closed = false;
    let retry = 0;
    let timer = null;

    const snapshot = async () => {
      try {
        const data = await api.getCourierLocations();
        const next = {};
        (data.couriers || []).forEach((c) => { next[c.courier_id] = c; });
        setById(next);
      } catch (e) {
        console.warn('[locations] snapshot failed', e);
      }
    };

    const connect = async () => {
      if (closed) return;
      try {
        const { token } = await api.getLocationsStreamToken();
        es = new EventSource(`${API_BASE}/courier-assignment/locations/stream?token=${encodeURIComponent(token)}`);
        es.onopen = () => { retry = 0; snapshot(); };
        es.onmessage = (ev) => {
          try {
            const data = JSON.parse(ev.data);
            if (data.type === 'courier_location') {
              setById((prev) => ({ ...prev, [data.courier_id]: data }));
            } else if (data.type === 'courier_location_removed') {
              setById((prev) => { const n = { ...prev }; delete n[data.courier_id]; return n; });
            }
          } catch (e) { /* мусор в потоке — игнорируем */ }
        };
        es.onerror = () => {
          es.close();
          if (!closed) timer = setTimeout(connect, Math.min(30000, 2000 * 2 ** Math.min(retry++, 4)));
        };
      } catch (e) {
        if (!closed) timer = setTimeout(connect, 5000);
      }
    };

    snapshot();
    connect();
    const ageTimer = setInterval(() => setTick((t) => t + 1), 30000);
    return () => {
      closed = true;
      if (es) es.close();
      clearTimeout(timer);
      clearInterval(ageTimer);
    };
  }, [enabled]);

  return useMemo(() => Object.values(byId).map((c) => {
    const age = c.updated_at ? Math.max(0, Math.round((Date.now() - new Date(c.updated_at).getTime()) / 1000)) : c.age_s;
    return { ...c, id: c.courier_id, age_s: age };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [byId, tick]);
}
